const useConfiguratorCalculations = data => {
   const {
      trailerData,
      allSelectedCustomizePackages,
      allSelectedEquipmentPackages,
      selectedPackages,
      warrantyData,
      customerDownPaymentOffer = "",
      downPaymentAmount = "",
   } = data

   let trailerPrice = Number(trailerData?.price || 0)

   let warrantyPrice = warrantyData?.length
      ? warrantyData?.reduce(
           (total, item) => total + Number(item?.price || 0),
           0
        )
      : 0

   let totalCustomizePackagesPrice = Object.values(
      allSelectedCustomizePackages || {}
   ).reduce((sum, pkg) => sum + parseFloat(pkg.price || 0), 0)

   let totalCustomizePackagesVariationPrice = Object.values(
      allSelectedCustomizePackages || {}
   ).reduce((sum, pkg) => {
      const variationsPrice =
         pkg.selectedVariations?.reduce(
            (subSum, variation) => subSum + parseFloat(variation?.price || 0),
            0
         ) || 0

      return sum + variationsPrice
   }, 0)

   let totalEquipmentPackagesPrice = Object.values(
      allSelectedEquipmentPackages || {}
   ).reduce((sum, pkg) => sum + parseFloat(pkg.price || 0), 0)

   let totalEquipmentPackagesVariationPrice = Object.values(
      allSelectedEquipmentPackages || {}
   ).reduce((sum, pkg) => {
      const variationsPrice =
         pkg.selectedVariations?.reduce(
            (subSum, variation) => subSum + parseFloat(variation?.price || 0),
            0
         ) || 0

      return sum + variationsPrice
   }, 0)

   let totalPackagePrice = Object.values(selectedPackages || {}).reduce(
      (sum, pkg) => {
         let itemsLength = Object.keys(pkg.items).length

         if (pkg?.selectedItems?.length == itemsLength) {
            return sum + parseFloat(pkg.price || 0)
         } else if (pkg?.selectedItems?.length < itemsLength) {
            return (
               sum +
               pkg?.selectedItems?.reduce((a, b) => {
                  return a + b?.itemPrice
               }, 0)
            )
         }
      },
      0
   )

   const summedUp = [
      warrantyPrice,
      trailerPrice,
      totalPackagePrice,
      totalCustomizePackagesPrice,
      totalCustomizePackagesVariationPrice,
      totalEquipmentPackagesPrice,
      totalEquipmentPackagesVariationPrice,
   ].reduce(
      (accumulator, currentValue) => Number(accumulator) + Number(currentValue),
      0
   )

   const totalSum = parseFloat(summedUp.toFixed(2))

   const getSingleSelectedPackagePriceConfiguration = pkg => {
      if (!pkg.id) return ""

      let isNoItemSelected = false
      let isEligibleForDiscount = false
      let discountedCost = pkg.price
      let selectedItemsCost = pkg.selectedItems.reduce((a, b) => {
         return a + b.itemPrice
      }, 0)

      let discountAmount = Math.abs(selectedItemsCost - discountedCost)
      let itemsLength = Object.keys(pkg.items).length

      if (pkg.selectedItems.length == itemsLength) {
         isEligibleForDiscount = true
      } else if (
         pkg.selectedItems.length < itemsLength &&
         pkg.selectedItems.length >= 1
      ) {
         isNoItemSelected = false
         isEligibleForDiscount = false
      } else if (!pkg.selectedItems?.length) {
         isNoItemSelected = true
         isEligibleForDiscount = false
      }

      return {
         discountedCost,
         selectedItemsCost,
         isEligibleForDiscount,
         discountAmount,
         isNoItemSelected,
      }
   }

   return {
      trailerId: data?.trailerData?.id,
      warrantyPrice,
      trailerPrice,
      totalCustomizePackagesPrice,
      totalCustomizePackagesVariationPrice,
      totalEquipmentPackagesPrice,
      totalEquipmentPackagesVariationPrice,
      totalPackagePrice,
      totalSum,
      getSingleSelectedPackagePriceConfiguration,
      customerDownPaymentOffer,
      downPaymentAmount,
   }
}

export default useConfiguratorCalculations
